import { useEffect } from 'react';

import { TFormalOffers } from '@helpers/FormalOffers/formalOffers.types';
import { tracking } from '@iwoca/frontend-tracking-library';

import { FundingProgressIndicator } from '../../../../funding/fundingSteps/FundingProgessIndicator/FundingProgressIndicator';
import { MicroLoanOfferView } from '../../../approvedView/microLoanOfferView/MicroLoanOfferView';

export const MicroOfferPage = ({ offers }: { offers: TFormalOffers }) => {
    useEffect(() => {
        tracking.ampli.approvedViewVisited({
            status: 'micro',
            offers_page_version: '1.0'
        });
    }, []);

    return (
        <>
            <FundingProgressIndicator step={1} />
            <MicroLoanOfferView formalOfferId={offers[0].offer_id} />
        </>
    );
};
